import { Flex, Layout, List, Menu } from 'antd';
import styled from 'styled-components';

export const ListContainer = styled(Flex).attrs({ vertical: true, flex: 1 })`
  padding: 16px 24px;
  overflow-y: auto;
  background: #fff;
`;
